import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class FeedbackControlService {
  #onOpenFeedbackModal = new EventEmitter();
  #showFeedbackModal = false;
  #currentUrlSegments: string[] = [];

  get CurrentUrlSegments() {
    return this.#currentUrlSegments;
  }
  
  get onOpenFeedbackModal(): EventEmitter<any> {
    return this.#onOpenFeedbackModal;
  }
  
  get showFeedbackModal() {
    const currentUrlSegments = this.getUrlSegments();
    const alreadyShowingFeedbackModal = this.#showFeedbackModal;
    if (alreadyShowingFeedbackModal) {
      if (this.#currentUrlSegments.join('/') !== currentUrlSegments.join('/')) {
        this.closeFeedbackModal();
      }
    }
    return this.#showFeedbackModal;
  }

  constructor(private router: Router) {
  }
  
  getUrlSegments(): string[] {
    // Get the current URL
    return this.router.url.split('/');
  }

  openFeedbackModal() {
    this.#currentUrlSegments = this.getUrlSegments();
    this.#showFeedbackModal = true;
    this.#onOpenFeedbackModal.emit();
  }

  closeFeedbackModal() {
    this.#showFeedbackModal = false;
  }
}
